/* ============ TRUESELF QUIZ – SHOPIFY JS ============ */
/* Scans the DOM for .ts-quiz-wrap containers and initializes each one. */

(function () {
  'use strict';

  function initQuiz(root) {
    if (root.dataset.tsInit === '1') return;
    root.dataset.tsInit = '1';

    var screens = Array.prototype.slice.call(root.querySelectorAll('.screen'));
    if (screens.length === 0) return;

    var order = screens.map(function (s) { return s.dataset.screen; });
    var answers = {};
    var history = [];

    function showScreen(name) {
      screens.forEach(function (s) { s.classList.remove('active'); });
      var el = root.querySelector('.screen[data-screen="' + name + '"]');
      if (el) {
        el.classList.add('active');
        try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }
    }

    function collect(current, screenEl) {
      var type = screenEl.dataset.blockType;

      if (type === 'weight_height') {
        var f1 = screenEl.querySelector('input[name="field_1"]');
        var f2 = screenEl.querySelector('input[name="field_2"]');
        var v1 = f1 ? f1.value.trim() : '';
        var v2 = f2 ? f2.value.trim() : '';
        if (!v1 || !v2) { alert('Please fill both fields to continue.'); return false; }
        answers[current] = { field_1: v1, field_2: v2 };
        return true;
      }

      if (type === 'portrait_pick' || type === 'age_range' || type === 'timeline') {
        var picked = screenEl.querySelector('input:checked');
        if (!picked) { alert('Please select an option to continue.'); return false; }
        answers[current] = picked.value;
        return true;
      }

      if (type === 'goal_multi' || type === 'multi') {
        var picks = Array.prototype.slice
          .call(screenEl.querySelectorAll('input:checked'))
          .map(function (i) { return i.value; });
        if (picks.length === 0) { alert('Please select at least one option.'); return false; }
        answers[current] = picks;
        return true;
      }

      return true; // start screen, result screen — no collection
    }

    /* -------- Continue buttons -------- */
    root.querySelectorAll('.cta-btn[data-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var screenEl = btn.closest('.screen');
        var current = screenEl.dataset.screen;
        var next = btn.dataset.next;
        if (!collect(current, screenEl)) return;
        if (!next) return; // last block, no next
        history.push(current);
        showScreen(next);
      });
    });

    /* -------- Back -------- */
    root.querySelectorAll('.back-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (history.length > 0) {
          showScreen(history.pop());
        } else {
          var screenEl = btn.closest('.screen');
          var idx = order.indexOf(screenEl.dataset.screen);
          if (idx > 0) showScreen(order[idx - 1]);
        }
      });
    });

    /* -------- Close -------- */
    root.querySelectorAll('.close-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!confirm('Exit the quiz? Your progress will be lost.')) return;
        history.length = 0;
        Object.keys(answers).forEach(function (k) { delete answers[k]; });
        root.querySelectorAll('.opt.selected, .portrait-card.selected, .age-card.selected')
          .forEach(function (el) { el.classList.remove('selected'); });
        root.querySelectorAll('input[type="checkbox"], input[type="radio"]')
          .forEach(function (i) { i.checked = false; });
        root.querySelectorAll('.wh-inputs input').forEach(function (i) { i.value = ''; });
        showScreen(order[0]);
      });
    });

    /* -------- Multi-select cards -------- */
    root.querySelectorAll('.opt-grid[data-multi="true"] .opt').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        var input = opt.querySelector('input');
        var isExclusive = input.dataset.exclusive === 'true';
        var grid = opt.closest('.opt-grid');
        if (isExclusive) {
          grid.querySelectorAll('.opt').forEach(function (o) {
            o.classList.remove('selected');
            o.querySelector('input').checked = false;
          });
          input.checked = true;
          opt.classList.add('selected');
        } else {
          grid.querySelectorAll('input[data-exclusive="true"]').forEach(function (ex) {
            if (ex.checked) {
              ex.checked = false;
              ex.closest('.opt').classList.remove('selected');
            }
          });
          input.checked = !input.checked;
          opt.classList.toggle('selected', input.checked);
        }
      });
    });

    /* -------- Timeline single-select -------- */
    root.querySelectorAll('.opt-grid-tl .opt').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        var grid = opt.closest('.opt-grid-tl');
        grid.querySelectorAll('.opt').forEach(function (o) {
          o.classList.remove('selected');
          o.querySelector('input').checked = false;
        });
        opt.querySelector('input').checked = true;
        opt.classList.add('selected');
      });
    });

    /* -------- Portrait cards -------- */
    root.querySelectorAll('.portrait-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        var grid = card.closest('.portrait-grid');
        grid.querySelectorAll('.portrait-card').forEach(function (c) {
          c.classList.remove('selected');
          c.querySelector('input').checked = false;
        });
        card.querySelector('input').checked = true;
        card.classList.add('selected');
      });
    });

    /* -------- Age cards -------- */
    root.querySelectorAll('.age-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        var grid = card.closest('.age-grid');
        grid.querySelectorAll('.age-card').forEach(function (c) {
          c.classList.remove('selected');
          c.querySelector('input').checked = false;
        });
        card.querySelector('input').checked = true;
        card.classList.add('selected');
      });
    });

    /* -------- Add-to-cart forms (Shopify native) -------- */
    root.querySelectorAll('.pc-atc-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.pc-add');
        var originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.textContent = '✓ Added';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
          // Dispatch event so theme cart drawer can update
          document.dispatchEvent(new CustomEvent('trueself:cart:added', { detail: data }));
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          btn.textContent = 'Error – try again';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        });
      });
    });

    /* -------- Final CTA -------- */
    var finalBtn = root.querySelector('.cta-final');
    if (finalBtn) {
      finalBtn.addEventListener('click', function () {
        var url = finalBtn.dataset.finalUrl;
        // Persist answers so a next page / cart can read them
        try {
          window.sessionStorage.setItem('trueself_quiz_answers', JSON.stringify(answers));
        } catch (e) {}
        // Dispatch event
        document.dispatchEvent(new CustomEvent('trueself:quiz:complete', { detail: answers }));
        console.log('TrueSelf quiz answers:', answers);

        if (url) {
          window.location.href = url;
        } else {
          alert('Quiz complete! Answers logged to console.');
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.ts-quiz-wrap').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
